/**
 * GENERATED by `bun run scripts/sync-field-labels.ts`. Do not edit.
 *
 * @remarks
 * Labels for request field names and their selectable options, in es. Importing this module
 * registers them and re-renders every mounted form, exactly like the chrome catalogue beside it.
 * Regenerate with `bun run generate`; the source of truth is the API, not this file.
 */

import { registerFieldLabels } from '../../i18n/registry.js';

registerFieldLabels('es', {
	fields: {
		activity: 'Actividad',
		afterSunset: 'Después de la puesta de sol',
		allowDuplicates: 'Permitir cartas duplicadas',
		allowReversals: 'Permitir cartas invertidas',
		angelDating: 'Datación del nombre del día',
		annualFromYear: 'Primer año de los pilares anuales',
		annualYears: 'Número de pilares anuales',
		antardasha: 'Antardasha',
		approximateDate: 'Fecha aproximada',
		arcana: 'Arcano',
		aspectTypes: 'Tipos de aspecto',
		atbashOutput: 'Salida de Atbash y Albam',
		avasthaInfo: 'Incluir detalles de avastha',
		avoidAnimal: 'Signo animal a proteger',
		ayadiText: 'Familia de textos Ayadi',
		ayanamsa: 'Ayanamsa',
		ayanamsaValue: 'Valor de ayanamsa personalizado',
		biorhythm: 'Biorritmo',
		birthData: 'Datos de nacimiento',
		birthDate: 'Fecha de nacimiento',
		birthLatitude: 'Latitud de nacimiento',
		birthLongitude: 'Longitud de nacimiento',
		birthTime: 'Hora de nacimiento',
		breadth: 'Anchura',
		chakra: 'Chakra',
		ciphers: 'Cifrados a devolver',
		circumference: 'Circunferencia',
		color: 'Color',
		context: 'Dónde lo viste',
		coordinateSystem: 'Sistema de coordenadas',
		correlation: 'Constante de correlación',
		count: 'Cantidad',
		currentYear: 'Año actual',
		cusps: 'Cúspides',
		cuts: 'Cortes de esquina',
		dasha: 'Señores de dasha',
		date: 'Fecha',
		datetime: 'Fecha y hora',
		day: 'Día',
		dayBoundary: 'Inicio del día',
		depth: 'Profundidad, de norte a sur',
		direction: 'Dirección',
		directionScheme: 'Lectura de dirección',
		division: 'Carta divisional',
		domainWeights: 'Ponderación de dominios',
		domains: 'Dominios',
		door: 'Coordenadas de la puerta',
		doorPosition: 'Posición de la puerta en el lado',
		doshaClock: 'Referencia horaria de los doshas',
		element: 'Elemento',
		endDate: 'Fecha de fin',
		endDatetime: 'Fecha y hora de fin',
		expression: 'Número de expresión',
		extensions: 'Extensiones de esquina',
		facing: 'Orientación',
		facingDegrees: 'Orientación en grados',
		family: 'Familia de yoga',
		firstName: 'Primer nombre',
		firstNameHebrew: 'Primer nombre en hebreo',
		focus: 'Enfoque',
		fullName: 'Nombre completo',
		gainHouses: 'Casas de ganancia',
		gender: 'Sexo',
		grid: 'Cuadrícula del mandala',
		hastaInches: 'Longitud de un hasta en pulgadas',
		hemisphere: 'Hemisferio',
		horaryNumber: 'Número horario',
		hourClock: 'Referencia horaria',
		houseSystem: 'Sistema de casas',
		id: 'ID',
		include: 'Cuerpos adicionales',
		includeMatches: 'Incluir coincidencias de igual valor',
		interpretation: 'Significado de la posición',
		intervalMinutes: 'Intervalo en minutos',
		isLeapMonth: 'Mes intercalar',
		iso2: 'Código de país',
		kua: 'Número Kua',
		lang: 'Idioma',
		latinCiphers: 'Puntuar también los cifrados latinos',
		latitude: 'Latitud',
		leapDayPolicy: 'Dónde cae el 29 de febrero',
		length: 'Longitud',
		letter: 'Letra inicial',
		letterAttribution: 'Lectura de atribución de letras',
		lifePath: 'Número del camino de vida',
		limit: 'Resultados por página',
		lines: 'Patrón de líneas',
		longCount: 'Cuenta Larga',
		longitude: 'Longitud',
		lossHouses: 'Casas de pérdida',
		lunarDay: 'Día lunar',
		lunarMonth: 'Mes lunar',
		lunarYear: 'Año lunar',
		mahadasha: 'Mahadasha',
		members: 'Miembros del grupo',
		minSignificance: 'Importancia mínima',
		minStrength: 'Fuerza mínima',
		misparGadol: 'Método de mispar gadol',
		modernPlanets: 'Incluir planetas modernos',
		month: 'Mes',
		moonWindows: 'Ventanas lunares',
		muhurtaText: 'Texto de muhurta',
		name: 'Nombre',
		nameHebrew: 'Nombre en hebreo',
		natalChart: 'Carta natal',
		nodeType: 'Tipo de nodo lunar',
		number: 'Número',
		offset: 'Resultados a omitir',
		orb: 'Orbe',
		perimeter: 'Perímetro',
		period: 'Período',
		person1: 'Persona 1',
		person2: 'Persona 2',
		personA: 'Persona A',
		personB: 'Persona B',
		planet: 'Planeta',
		planets: 'Planetas',
		plot: 'Parcela',
		polygon: 'Contorno',
		positions: 'Posiciones de la tirada',
		pratyantardasha: 'Pratyantardasha',
		q: 'Buscar',
		question: 'Tu pregunta',
		relocationLatitude: 'Latitud de reubicación',
		relocationLongitude: 'Longitud de reubicación',
		returnDate: 'Fecha de retorno',
		returnYear: 'Año de retorno',
		ritucharyaScheme: 'Esquema de estaciones',
		rituZodiac: 'Zodiaco de las estaciones',
		road: 'Lado del camino',
		rooms: 'Habitaciones',
		rulingPlanets: 'Planetas regentes',
		scheme: 'Esquema de karakas',
		secondName: 'Segundo nombre',
		secondNameHebrew: 'Segundo nombre en hebreo',
		seed: 'Semilla',
		sephirotSystem: 'Lectura de sefirot',
		sign: 'Signo zodiacal',
		sign1: 'Primer signo animal',
		sign2: 'Segundo signo animal',
		signDoshaScheme: 'Tabla de humores por signo',
		significators: 'Incluir significadores KP',
		slopeLowDirection: 'Dirección hacia la que cae el terreno',
		slopeSchool: 'Escuela de nivel del terreno',
		sookshma: 'Sookshma',
		soulUrge: 'Número del alma',
		spreadName: 'Nombre de la tirada',
		startDate: 'Fecha de inicio',
		startDatetime: 'Fecha y hora de inicio',
		strictOrbs: 'Usar orbes más estrictos',
		suit: 'Palo',
		system: 'Sistema de avastha',
		targetDate: 'Fecha objetivo',
		targetMonth: 'Mes objetivo',
		text: 'Palabra o nombre',
		textHebrew: 'Palabra o nombre en hebreo',
		time: 'Hora',
		timezone: 'Zona horaria',
		top: 'Mejores eventos por ventana',
		transitDate: 'Fecha de tránsito',
		transitTime: 'Hora de tránsito',
		transliteration: 'Esquema de transliteración',
		treeVariant: 'Disposición del árbol',
		type: 'Tipo de patrón',
		unit: 'Unidad',
		vedic: 'Védica',
		vyayaFormula: 'Fórmula de vyaya',
		water: 'Dirección del agua estancada',
		weights: 'Ponderación de capas',
		western: 'Occidental',
		width: 'Ancho, de este a oeste',
		x: 'Distancia al este',
		y: 'Distancia al norte',
		year: 'Año',
		yearBearerSystem: 'Escuela de portador del año',
		yearBoundary: 'Inicio del año',
		yearStart: 'Inicio de la rueda del año',
		zodiac: 'Signo zodiacal',
	},
	enums: {
		'arcana.major': 'Arcano Mayor',
		'arcana.minor': 'Arcano Menor',
		'ayanamsa.custom': 'Personalizado',
		'ayanamsa.kp-newcomb': 'KP Newcomb',
		'ayanamsa.kp-old': 'KP Old',
		'ayanamsa.lahiri': 'Lahiri',
		'ayanamsa.raman': 'B.V. Raman',
		'chakra.Crown': 'Corona',
		'chakra.Heart': 'Corazón',
		'chakra.Root': 'Raíz',
		'chakra.Sacral': 'Sacro',
		'chakra.Solar Plexus': 'Plexo Solar',
		'chakra.Third Eye': 'Tercer Ojo',
		'chakra.Throat': 'Garganta',
		'context.address': 'Dirección',
		'context.clock': 'Reloj',
		'context.license-plate': 'Matrícula',
		'context.phone': 'Teléfono',
		'context.price': 'Precio',
		'context.receipt': 'Recibo',
		'coordinateSystem.sidereal': 'Sideral',
		'coordinateSystem.tropical': 'Tropical',
		'correlation.astronomical-584285': 'Astronómica',
		'correlation.gmt-584283': 'GMT',
		'correlation.martin-skidmore-584286': 'Martin-Skidmore',
		'correlation.martinez-hernandez-584281': 'Martinez-Hernandez',
		'directionScheme.landa': 'Landa',
		'directionScheme.madrid-codex': 'Códice de Madrid',
		'yearBearerSystem.campeche': 'Campeche del Clásico Tardío',
		'yearBearerSystem.classic': 'Clásico',
		'yearBearerSystem.colonial-yucatec': 'Yucateco posclásico y colonial',
		'element.Air': 'Aire',
		'element.Earth': 'Tierra',
		'element.Fire': 'Fuego',
		'element.Storm': 'Tormenta',
		'element.Water': 'Agua',
		'family.akriti': 'Akriti',
		'family.asraya': 'Asraya',
		'family.classical': 'Clásica',
		'family.dala': 'Dala',
		'family.sankhya': 'Sankhya',
		'focus.finance': 'Finanzas',
		'focus.general': 'General',
		'houseSystem.equal': 'Casas iguales',
		'houseSystem.koch': 'Koch',
		'houseSystem.placidus': 'Placidus',
		'houseSystem.whole-sign': 'Signo entero',
		'lang.de': 'Alemán',
		'lang.en': 'Inglés',
		'lang.es': 'Español',
		'lang.fr': 'Francés',
		'lang.hi': 'Hindi',
		'lang.pt': 'Portugués',
		'lang.ru': 'Ruso',
		'lang.tr': 'Turco',
		'lang.zh-Hans': 'Chino (simplificado)',
		'lang.zh-Hant': 'Chino (tradicional)',
		'nodeType.mean': 'Nodo medio',
		'nodeType.true': 'Nodo verdadero',
		'planet.Sun': 'Sol',
		'planet.Moon': 'Luna',
		'planet.Mars': 'Marte',
		'planet.Mercury': 'Mercurio',
		'planet.Jupiter': 'Júpiter',
		'planet.Venus': 'Venus',
		'planet.Saturn': 'Saturno',
		'mahadasha.Sun': 'Sol',
		'mahadasha.Moon': 'Luna',
		'mahadasha.Mars': 'Marte',
		'mahadasha.Mercury': 'Mercurio',
		'mahadasha.Jupiter': 'Júpiter',
		'mahadasha.Venus': 'Venus',
		'mahadasha.Saturn': 'Saturno',
		'mahadasha.Rahu': 'Nodo Norte',
		'mahadasha.Ketu': 'Nodo Sur',
		'antardasha.Sun': 'Sol',
		'antardasha.Moon': 'Luna',
		'antardasha.Mars': 'Marte',
		'antardasha.Mercury': 'Mercurio',
		'antardasha.Jupiter': 'Júpiter',
		'antardasha.Venus': 'Venus',
		'antardasha.Saturn': 'Saturno',
		'antardasha.Rahu': 'Nodo Norte',
		'antardasha.Ketu': 'Nodo Sur',
		'pratyantardasha.Sun': 'Sol',
		'pratyantardasha.Moon': 'Luna',
		'pratyantardasha.Mars': 'Marte',
		'pratyantardasha.Mercury': 'Mercurio',
		'pratyantardasha.Jupiter': 'Júpiter',
		'pratyantardasha.Venus': 'Venus',
		'pratyantardasha.Saturn': 'Saturno',
		'pratyantardasha.Rahu': 'Nodo Norte',
		'pratyantardasha.Ketu': 'Nodo Sur',
		'sookshma.Sun': 'Sol',
		'sookshma.Moon': 'Luna',
		'sookshma.Mars': 'Marte',
		'sookshma.Mercury': 'Mercurio',
		'sookshma.Jupiter': 'Júpiter',
		'sookshma.Venus': 'Venus',
		'sookshma.Saturn': 'Saturno',
		'sookshma.Rahu': 'Nodo Norte',
		'sookshma.Ketu': 'Nodo Sur',
		'scheme.eight': 'Ocho karakas',
		'scheme.seven': 'Siete karakas',
		'suit.cups': 'Copas',
		'suit.pentacles': 'Pentáculos',
		'suit.swords': 'Espadas',
		'suit.wands': 'Bastos',
		'system.baladi': 'Baladi',
		'system.deeptadi': 'Deeptadi',
		'system.jagradadi': 'Jagradadi',
		'type.compound': 'Compuesto',
		'type.master': 'Maestro',
		'type.mirror': 'Espejo',
		'type.repeating': 'Repetido',
		'type.root': 'Raíz',
		'type.sequential': 'Secuencial',
		'activity.burial': 'Entierro',
		'activity.construction': 'Construcción',
		'activity.groundbreaking': 'Inicio de obra',
		'activity.medical-treatment': 'Tratamiento médico',
		'activity.moving-house': 'Mudanza',
		'activity.opening-business': 'Apertura de un negocio',
		'activity.praying': 'Oración y ofrendas',
		'activity.signing-contracts': 'Firma de contratos',
		'activity.travel': 'Viaje',
		'activity.wedding': 'Boda',
		'avoidAnimal.rat': 'Rata',
		'avoidAnimal.ox': 'Buey',
		'avoidAnimal.tiger': 'Tigre',
		'avoidAnimal.rabbit': 'Conejo',
		'avoidAnimal.dragon': 'Dragón',
		'avoidAnimal.snake': 'Serpiente',
		'avoidAnimal.horse': 'Caballo',
		'avoidAnimal.goat': 'Cabra',
		'avoidAnimal.monkey': 'Mono',
		'avoidAnimal.rooster': 'Gallo',
		'avoidAnimal.dog': 'Perro',
		'avoidAnimal.pig': 'Cerdo',
		'sign1.rat': 'Rata',
		'sign1.ox': 'Buey',
		'sign1.tiger': 'Tigre',
		'sign1.rabbit': 'Conejo',
		'sign1.dragon': 'Dragón',
		'sign1.snake': 'Serpiente',
		'sign1.horse': 'Caballo',
		'sign1.goat': 'Cabra',
		'sign1.monkey': 'Mono',
		'sign1.rooster': 'Gallo',
		'sign1.dog': 'Perro',
		'sign1.pig': 'Cerdo',
		'sign2.rat': 'Rata',
		'sign2.ox': 'Buey',
		'sign2.tiger': 'Tigre',
		'sign2.rabbit': 'Conejo',
		'sign2.dragon': 'Dragón',
		'sign2.snake': 'Serpiente',
		'sign2.horse': 'Caballo',
		'sign2.goat': 'Cabra',
		'sign2.monkey': 'Mono',
		'sign2.rooster': 'Gallo',
		'sign2.dog': 'Perro',
		'sign2.pig': 'Cerdo',
		'dayBoundary.early-zi': 'Hora Zi temprana',
		'dayBoundary.midnight': 'Medianoche',
		'dayBoundary.split-zi': 'Hora Zi dividida',
		'facing.North': 'Norte',
		'facing.Northeast': 'Noreste',
		'facing.East': 'Este',
		'facing.Southeast': 'Sureste',
		'facing.South': 'Sur',
		'facing.Southwest': 'Suroeste',
		'facing.West': 'Oeste',
		'facing.Northwest': 'Noroeste',
		'direction.North': 'Norte',
		'direction.Northeast': 'Noreste',
		'direction.East': 'Este',
		'direction.Southeast': 'Sureste',
		'direction.South': 'Sur',
		'direction.Southwest': 'Suroeste',
		'direction.West': 'Oeste',
		'direction.Northwest': 'Noroeste',
		'road.North': 'Norte',
		'road.Northeast': 'Noreste',
		'road.East': 'Este',
		'road.Southeast': 'Sureste',
		'road.South': 'Sur',
		'road.Southwest': 'Suroeste',
		'road.West': 'Oeste',
		'road.Northwest': 'Noroeste',
		'slopeLowDirection.North': 'Norte',
		'slopeLowDirection.Northeast': 'Noreste',
		'slopeLowDirection.East': 'Este',
		'slopeLowDirection.Southeast': 'Sureste',
		'slopeLowDirection.South': 'Sur',
		'slopeLowDirection.Southwest': 'Suroeste',
		'slopeLowDirection.West': 'Oeste',
		'slopeLowDirection.Northwest': 'Noroeste',
		'water.North': 'Norte',
		'water.Northeast': 'Noreste',
		'water.East': 'Este',
		'water.Southeast': 'Sureste',
		'water.South': 'Sur',
		'water.Southwest': 'Suroeste',
		'water.West': 'Oeste',
		'water.Northwest': 'Noroeste',
		'facing.N1': 'Norte 1',
		'facing.N2': 'Norte 2',
		'facing.N3': 'Norte 3',
		'facing.NE1': 'Noreste 1',
		'facing.NE2': 'Noreste 2',
		'facing.NE3': 'Noreste 3',
		'facing.E1': 'Este 1',
		'facing.E2': 'Este 2',
		'facing.E3': 'Este 3',
		'facing.SE1': 'Sureste 1',
		'facing.SE2': 'Sureste 2',
		'facing.SE3': 'Sureste 3',
		'facing.S1': 'Sur 1',
		'facing.S2': 'Sur 2',
		'facing.S3': 'Sur 3',
		'facing.SW1': 'Suroeste 1',
		'facing.SW2': 'Suroeste 2',
		'facing.SW3': 'Suroeste 3',
		'facing.W1': 'Oeste 1',
		'facing.W2': 'Oeste 2',
		'facing.W3': 'Oeste 3',
		'facing.NW1': 'Noroeste 1',
		'facing.NW2': 'Noroeste 2',
		'facing.NW3': 'Noroeste 3',
		'facing.ren': 'Ren (Norte 1)',
		'facing.zi': 'Zi (Norte 2)',
		'facing.gui': 'Gui (Norte 3)',
		'facing.chou': 'Chou (Noreste 1)',
		'facing.gen': 'Gen (Noreste 2)',
		'facing.yin': 'Yin (Noreste 3)',
		'facing.jia': 'Jia (Este 1)',
		'facing.mao': 'Mao (Este 2)',
		'facing.yi': 'Yi (Este 3)',
		'facing.chen': 'Chen (Sureste 1)',
		'facing.xun': 'Xun (Sureste 2)',
		'facing.si': 'Si (Sureste 3)',
		'facing.bing': 'Bing (Sur 1)',
		'facing.wu': 'Wu (Sur 2)',
		'facing.ding': 'Ding (Sur 3)',
		'facing.wei': 'Wei (Suroeste 1)',
		'facing.kun': 'Kun (Suroeste 2)',
		'facing.shen': 'Shen (Suroeste 3)',
		'facing.geng': 'Geng (Oeste 1)',
		'facing.you': 'You (Oeste 2)',
		'facing.xin': 'Xin (Oeste 3)',
		'facing.xu': 'Xu (Noroeste 1)',
		'facing.qian': 'Qian (Noroeste 2)',
		'facing.hai': 'Hai (Noroeste 3)',
		'gender.female': 'Femenino',
		'gender.male': 'Masculino',
		'hourClock.clock': 'Hora civil',
		'hourClock.local-mean': 'Hora media local',
		'hourClock.solar': 'Hora solar verdadera',
		'yearBoundary.li-chun': 'Inicio de la Primavera',
		'yearBoundary.lunar-new-year': 'Año Nuevo chino',
		'zodiac.aries': 'Aries',
		'zodiac.taurus': 'Tauro',
		'zodiac.gemini': 'Géminis',
		'zodiac.cancer': 'Cáncer',
		'zodiac.leo': 'Leo',
		'zodiac.virgo': 'Virgo',
		'zodiac.libra': 'Libra',
		'zodiac.scorpio': 'Escorpio',
		'zodiac.sagittarius': 'Sagitario',
		'zodiac.capricorn': 'Capricornio',
		'zodiac.aquarius': 'Acuario',
		'zodiac.pisces': 'Piscis',
		'sign.aries': 'Aries',
		'sign.taurus': 'Tauro',
		'sign.gemini': 'Géminis',
		'sign.cancer': 'Cáncer',
		'sign.leo': 'Leo',
		'sign.virgo': 'Virgo',
		'sign.libra': 'Libra',
		'sign.scorpio': 'Escorpio',
		'sign.sagittarius': 'Sagitario',
		'sign.capricorn': 'Capricornio',
		'sign.aquarius': 'Acuario',
		'sign.pisces': 'Piscis',
		'ayadiText.manasara': 'Manasara',
		'ayadiText.perimeter-texts': 'Textos perimetrales',
		'ayadiText.utpala': 'Utpala',
		'grid.64-pada': '64 pada Manduka',
		'grid.81-pada': '81 pada Paramasayika',
		'muhurtaText.kalaprakasika': 'Kalaprakasika',
		'muhurtaText.muhurta-chintamani': 'Muhurta Chintamani',
		'slopeSchool.brihat-samhita': 'Brihat Samhita',
		'slopeSchool.modern': 'Moderna',
		'type.bedroom': 'Dormitorio',
		'type.dining': 'Comedor',
		'type.entrance': 'Entrada principal',
		'type.kitchen': 'Cocina',
		'type.living': 'Sala de estar',
		'type.master-bedroom': 'Dormitorio principal',
		'type.puja': 'Sala de puja',
		'type.staircase': 'Escalera',
		'type.store': 'Almacén',
		'type.study': 'Estudio',
		'type.toilet': 'Baño',
		'type.water-storage': 'Tanque de agua',
		'unit.feet': 'Pies',
		'unit.hasta': 'Hasta',
		'unit.metres': 'Metros',
		'vyayaFormula.p3-14': 'Por tres, dividido entre catorce',
		'vyayaFormula.p9-10': 'Por nueve, dividido entre diez',
		'angelDating.lenain-blocks': 'Rueda civil fija',
		'angelDating.solar-longitude': 'Arco solar exacto',
		'atbashOutput.both': 'Palabra sustituida y su valor',
		'atbashOutput.string': 'Solo la palabra sustituida',
		'atbashOutput.value': 'Solo el valor',
		'leapDayPolicy.extend-previous': 'Extiende el período anterior',
		'leapDayPolicy.next-angel': 'Abre el período siguiente',
		'letterAttribution.golden-dawn': 'Golden Dawn',
		'letterAttribution.sefer-yetzirah-gra': 'Séfer Ietzirá, recensión Gra',
		'letterAttribution.sefer-yetzirah-saadia':
			'Séfer Ietzirá, recensión Saadia',
		'letterAttribution.sefer-yetzirah-short': 'Séfer Ietzirá, recensión breve',
		'misparGadol.finals-500-900': 'Formas finales como 500 a 900',
		'misparGadol.milui': 'Cada letra deletreada por completo',
		'sephirotSystem.classical': 'Clásica',
		'sephirotSystem.golden-dawn': 'Golden Dawn',
		'transliteration.letter-map-mathers': 'Mapa de letras hermético, 1887',
		'transliteration.letter-map-modern': 'Mapa de letras israelí moderno',
		'treeVariant.kircher': 'Kircher, 1652',
		'yearStart.march-20': '20 de marzo',
		'yearStart.march-21': '21 de marzo',
		'doshaClock.clock-hours': 'Cuadrícula horaria moderna',
		'doshaClock.sunrise-anchored': 'Tercios del día y la noche reales',
		'hemisphere.northern': 'Norte',
		'hemisphere.southern': 'Sur',
		'ritucharyaScheme.sutrasthana-6': 'Sutrasthana, seis estaciones',
		'ritucharyaScheme.vimana-8': 'Alternancia de Vimanasthana, con pravrt',
		'rituZodiac.nirayana': 'Nirayana, sideral',
		'rituZodiac.sayana': 'Sayana, tropical',
		'signDoshaScheme.bphs': 'Brihat Parasara Hora Sastra, por triplicidad',
		'signDoshaScheme.satyacharya': 'Extracto de Satyacharya',
		'id.rat': 'Rata',
		'id.ox': 'Buey',
		'id.tiger': 'Tigre',
		'id.rabbit': 'Conejo',
		'id.dragon': 'Dragón',
		'id.snake': 'Serpiente',
		'id.horse': 'Caballo',
		'id.goat': 'Cabra',
		'id.monkey': 'Mono',
		'id.rooster': 'Gallo',
		'id.dog': 'Perro',
		'id.pig': 'Cerdo',
		'id.head': 'Cabeza',
		'id.throat': 'Garganta',
		'id.g': 'Centro G',
		'id.heart': 'Corazón',
		'id.solar-plexus': 'Plexo Solar',
		'id.spleen': 'Bazo',
		'id.root': 'Raíz',
	},
});
